<object
  *ngIf="pathToIcon"
  [class]="iconClass"
  type="image/svg+xml"
  [attr.data]="pathToIcon | safeUrl"
  aria-label="icon"
></object>
